import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Usa localStorage por defecto
import { combineReducers } from 'redux';

import majesticReducer from './majesticSlice';
import ocrReducer from './ocrSlice';
import guestsReducer from '../../features/guests/guestsSlice';
import bookingReducer from '../../features/booking/bookingSlice';
import checkingReducer from '../../features/checking/checkingSlice';
import { ocrApi } from '../../services/ocrApi';
import { majesticResortsApi } from '../../services/majesticResortsApi';

// Configuracion de persistencia
const persistConfigGuests = {
  key: 'guests', // Clave específica para guests
  storage,
};
const persistConfigBooking = {
  key: 'booking',
  storage,
};
const persistConfigChecking = {
  key: 'checking',
  storage,
};
const persistConfigOcr = {
  key: 'ocr',
  storage,
};

// Combina tus reducers para persistencia al reducerRoot
const rootReducer = combineReducers({
  majestic: majesticReducer,
  guests: persistReducer(persistConfigGuests, guestsReducer),
  booking: persistReducer(persistConfigBooking, bookingReducer),
  checking: persistReducer(persistConfigChecking, checkingReducer),
  ocr: persistReducer(persistConfigOcr, ocrReducer),
  [ocrApi.reducerPath]: ocrApi.reducer,
  [majesticResortsApi.reducerPath]: majesticResortsApi.reducer,
});

// Configura el store con el reducer persistido
const store = configureStore({
  // reducer: persistedReducer,
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [
        'persist/PERSIST',
        'persist/FLUSH',
      ], // Ignora acciones de redux-persist
    },
  }).concat(ocrApi.middleware, majesticResortsApi.middleware),
});

// Crea el persistor
const persistor = persistStore(store);

setupListeners(store.dispatch);

// export default store;
export { store, persistor };
